import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
const _hoisted_2 = {
  class: "py-4 text-base text-left text-gray-900"
};
const _hoisted_3 = {
  class: "w-3/12 px-2 mb-1 bg-green-100"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "w-8/12 px-2 mb-1"
};
const _hoisted_6 = {
  class: "row-fluid py-2"
};
const _hoisted_7 = {
  class: "w-full"
};
const _hoisted_8 = {
  class: "py-2 flex justify-end"
};
import { onMounted, reactive, computed } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useInvoiceEmailStore } from "./useInvoiceEmailStore.js";
export default {
  __name: 'UpdateIntro',
  props: {
    state: {
      type: Object,
      required: true
    },
    alerts: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const props = __props;
    const invoiceEmailStore = useInvoiceEmailStore();
    onMounted(() => {
      introState.newBody = determineNewBody.value;
    });
    const introState = reactive({
      subjectOptions: [{
        id: " {client_name}",
        detail: "Client's Display Name in Leanlaw"
      }, {
        id: " {client_first_name}",
        detail: "Client's first name in Leanlaw"
      }, {
        id: " {client_last_name}",
        detail: "Client's last name in Leanlaw"
      }, {
        id: " {date_due}",
        detail: "Date when the invoice is due"
      }, {
        id: " {amount_due}",
        detail: "Amount due from the invoice"
      }, {
        id: " {responsible}",
        detail: "Name of the Responsible user in LeanLaw"
      }, {
        id: " {matter_name}",
        detail: "Matter name (will be blank on multi-matter invoices)"
      }],
      trustRequestSubjectOptions: [{
        id: " {client_name}",
        detail: "Client's Display Name in Leanlaw"
      }, {
        id: " {client_first_name}",
        detail: "Client's first name in Leanlaw"
      }, {
        id: " {client_last_name}",
        detail: "Client's last name in Leanlaw"
      }, {
        id: "{trust_amount_due}",
        detail: "Amount due from the trust request"
      }, {
        id: " {responsible}",
        detail: "Name of the Responsible user in LeanLaw"
      }, {
        id: "{matter_name}",
        detail: "Matter name (will be blank for client billed customers)"
      }]
    });
    const determineNewBody = computed(() => {
      switch (props.state.reminderMode) {
        case "1":
          return props.state.reminderBody;
        case "2":
          return props.state.trustRequestBody;
        case "0":
          return props.state.body;
        default:
          return "";
      }
    });
    const dynamicSubjectOption = computed(() => {
      switch (props.state.reminderMode) {
        case "0":
          return introState.subjectOptions;
        case "1":
          return introState.remainderSubjectOptions ? introState.remainderSubjectOptions : introState.subjectOptions;
        case "2":
          return introState.trustRequestSubjectOptions;
        default:
          return "";
      }
    });
    function save() {
      if (props.state.reminderMode === "1") {
        props.state.reminderBody = introState.newBody;
      } else if (props.state.reminderMode === "2") {
        props.state.trustRequestBody = introState.newBody;
      } else {
        props.state.body = introState.newBody;
      }
      invoiceEmailStore.toggleUpdateIntroModal();
    }
    function addCustomField(optionId) {
      props.alerts.success(`${optionId} successfully copied to clipboard.`);
      navigator.clipboard.writeText(optionId);
    }
    function close() {
      invoiceEmailStore.toggleUpdateIntroModal();
    }
    return (_ctx, _cache) => {
      const _component_v_textarea = _resolveComponent("v-textarea");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "text-left font-extrabold text-2xl"
      }, " Update Introduction Paragraph ", -1)), (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = _withModifiers($event => close(), ["prevent"])),
        width: "20",
        height: "20",
        class: "cursor-pointer ml-4 mb-4",
        viewBox: "0 0 16 16",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("g", {
        transform: "translate(2.000000, 2.000000)",
        stroke: "#242020"
      }, [_createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2"
      }), _createElementVNode("path", {
        d: "M0.24,0.24 L11.76,11.76",
        "stroke-width": "2",
        transform: "translate(6.000000, 6.000000) scale(-1, 1) translate(-6.000000, -6.000000) "
      })], -1)]))]))]), _createElementVNode("div", _hoisted_2, [_cache[6] || (_cache[6] = _createTextVNode(" This introduction paragraph will be used for all emails when sending ", -1)), _createElementVNode("span", null, _toDisplayString(__props.state.reminderMode === "2" ? "a trust request" : "an invoice"), 1), _cache[7] || (_cache[7] = _createTextVNode(". Any bracketed Keywords will be replaced by their corresponding value. ", -1))]), _createElementVNode("div", null, [_cache[9] || (_cache[9] = _createElementVNode("span", null, "Keyword Options (click to copy)", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicSubjectOption.value, option => {
        return _openBlock(), _createElementBlock("div", {
          class: "flex justify-between items-center",
          key: option.id
        }, [_createElementVNode("span", _hoisted_3, _toDisplayString(option.id), 1), _createElementVNode("span", {
          class: "no-print pl-6 px-2 mb-1 cursor-pointer w-1/12 bg-green-100",
          onClick: _withModifiers($event => addCustomField(option.id), ["prevent"])
        }, [...(_cache[8] || (_cache[8] = [_createElementVNode("span", {
          class: "fa fa-copy icon no-print"
        }, null, -1)]))], 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString(option.detail), 1)]);
      }), 128))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_v_textarea, {
        modelValue: introState.newBody,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => introState.newBody = $event),
        rows: "7",
        variant: "outlined"
      }, null, 8, ["modelValue"])])])]), _createElementVNode("div", _hoisted_8, [_createVNode(LlSecondaryButton, {
        class: "px-12 mr-4",
        onClick: _cache[2] || (_cache[2] = _withModifiers($event => close(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode(" Cancel ", -1)]))]),
        _: 1
      }), _createVNode(LlSecondaryButton, {
        color: "primary",
        class: "px-12",
        onClick: _cache[3] || (_cache[3] = _withModifiers($event => save(), ["prevent"]))
      }, {
        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode(" Save ", -1)]))]),
        _: 1
      })])]);
    };
  }
};